import { FilterOutlined } from "@ant-design/icons";
import { Box } from "@mui/material";
import { Collapse, Drawer, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { OptionFilter } from "../../utils/constants";
import { KeyValueObject } from "../../utils/models";
import "./FilterNavbar.scss";

interface Props {
    options: OptionFilter[],
    openFilter: boolean,
    onChangeStatus?: (key: string) => void,
    onChangeLocation?: (key: string) => void,
    onCloseFilter: () => void,
    displayStatus?: boolean,
    displayLocation?: boolean
}
const FilterNavbar: React.FC<Props> = (props) => {
    const { Panel } = Collapse;
    var countries: [] = useSelector((state: any) => state.countries.countries);
    var currentLanguage = useSelector((state: any) => state.language.currentLanguage);
    const { t } = useTranslation();
    const [openFilter, setOpenFilter] = useState(false);
    if (countries.length === 0 && localStorage.getItem("countries") != null) {
        var countriesStr: any = localStorage.getItem("countries");
        countries = JSON.parse(countriesStr);
    }
    if (currentLanguage.length === 0) {
        currentLanguage = localStorage.getItem("language");
      }
    const countriesOption = countries.map((item: any) => {
        var obj: KeyValueObject = {key: `${item.code}`, value: item.name};
        return obj;
    })
    const handleOnChange = (key: any) => {
        if (props.onChangeStatus !== undefined) {
            props.onChangeStatus(key);
        }
    }
    const handleOnChangeLocation = (key: string) => {
        if (props.onChangeLocation !== undefined) {
            props.onChangeLocation(key);
        }
    }

    useEffect(() => {
        setOpenFilter(props.openFilter)
    }, [props])

    return (
        <div className="filter-navbar">
            <Drawer
                title={
                <Box className="title-drawer">
                    <FilterOutlined style={{ marginRight: 10 }} />
                    {t("common.filter_navbar.title")}
                </Box>
                }
                placement="right"
                onClose={() => props.onCloseFilter()}
                open={openFilter}
            >
                <Collapse defaultActiveKey={["1"]}>
                <Panel header={t("common.filter_navbar.status")} key="1" className={props.displayStatus ? 'panel-ant' : 'hide_status'}>
                    <Select
                    className="select-filter"
                    defaultValue="all"
                    style={{ width: "100%" }}
                    options={props.options}
                    onChange={(key: any) => handleOnChange(key)}
                    />
                </Panel>
                <Panel header={t("common.filter_navbar.national")} key="2" className={props.displayLocation ? 'panel-ant' : 'hide_location'}>
                    <Select
                        className="select-filter"
                        style={{ width: "100%" }}
                        options={countriesOption}
                        onChange={(key: any) => handleOnChangeLocation(key)}
                    />
                </Panel>
                </Collapse>
            </Drawer>
        </div>
    )
}
export default FilterNavbar;